import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";

export default function PwaUpdateBanner() {
  const [reg, setReg] = useState(null);
  useEffect(() => {
    const h = (e) => setReg(e.detail);
    window.addEventListener("ponderr-sw-waiting", h);
    return () => window.removeEventListener("ponderr-sw-waiting", h);
  }, []);
  if (!reg) return null;
  const update = () => {
    const w = reg.waiting || (window.__ponderrSWReg && window.__ponderrSWReg.waiting);
    if (w) w.postMessage({ type: "SKIP_WAITING" });
    else window.location.reload();
  };
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] pf-surface border-2 pf-border rounded-xl shadow-xl px-4 py-3 flex items-center gap-3"
      data-testid="pwa-update-banner">
      <span className="text-sm font-bold">A new version of Ponderr is available.</span>
      <button className="pf-btn text-xs" onClick={update} data-testid="pwa-update-btn">
        <RefreshCw size={13} /> Refresh
      </button>
      <button onClick={() => setReg(null)} data-testid="pwa-update-dismiss"><X size={16} /></button>
    </div>
  );
}
